export const setValue = (resource, values) => ({
  type: 'react-redux-fetch/GET_FULFIL',
  resource: {
    name: '_',
  },
  method: 'get',
  request: {
    meta: {
      setOther: {
        resource,
        values,
      },
    },
  },
});
